import { Component, Input } from '@angular/core';
import FormRequest from '../common/formRequest';
import { FormBuilder, Validators } from '@angular/forms';
import { FiscoService } from 'src/app/app-core/services/fisco.service';

@Component({
  selector: 'app-form-request-default',
  templateUrl: './form-request-default.component.html',
  styleUrls: ['./form-request-default.component.scss']
})
export class FormRequestDefaultComponent extends FormRequest {

  @Input() subject;

  constructor(
    public fb: FormBuilder,
    public fiscoService: FiscoService,
  ) {
    super(fb, fiscoService);
    this._initForm();
    this.formChanges();
  }

  private _initForm(): void {
    const formVariants = this.fb.group({
      SOL_Descricao: ["", Validators.required],
      termoAceito: [null, Validators.requiredTrue]
    });

    this.form.setControl("formVariants", formVariants);
  }

  get isRefisRequest(): boolean {
    return (this.subject || '').trim().toUpperCase() === 'SOLICITAÇÃO DE ADESÃO AO REFIS';
  }
}